import * as React from 'react';
import { getI18n } from 'services/i18n-service';
import { translations } from 'types/translations';
import { OnlineIcon } from './online-icon';
import { OfflineIcon } from './offline-icon';

export interface ComponentProps {
  shouldDisplay: boolean;
  delay: number;
}

export interface ConnectedProps {
  language: string;
  isConnected: boolean;
}

export interface ActionProps {
  getConnectionStatus: () => void;
}

export type Props = ComponentProps & ConnectedProps & ActionProps;

export class ConnectionStatus extends React.Component<Props> {
  
  private pollConnectionStatus = setInterval(() => { 
    this.props.getConnectionStatus(); 
  }, this.props.delay);

  componentWillMount () {
    this.props.getConnectionStatus();
  }

  componentWillUnmount() {
    clearInterval(this.pollConnectionStatus);
  }

  public render() {
    const i18n = getI18n();
    const component = this.props.shouldDisplay
      ? ( 
        <span className="online-status">
          {
            this.props.isConnected
              ? <OnlineIcon />
              : <OfflineIcon />
          }
          {this.props.isConnected ? i18n.t(translations.Online) : i18n.t(translations.Offline)}
        </span>
      ) : <span />;

    return (
      component
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/connection-status/component.tsx